module.exports = __webpack_public_path__ + "static/about-us-banner-hero-three-e49ed85e84b4e24aa440bc921bcbb2bc.png";